<template>
  <div class="errors-forbidden-view">
    <h1>
      {{$t('error.titles.forbidden')}}
    </h1>
    <alert-box type="warning" icon="lock">
      {{$t('error.hints.forbidden')}}
    </alert-box>
  </div>
</template>

<script>
import AlertBox from '@/components/AlertBox';
import View from '@/mixins/View';

export default {
  name: 'errors-forbidden-view',
  mixins: [View],
  components: {
    AlertBox,
  },
  computed: {
    referrer() {
      return this.$route.query.from;
    },
  },
  i18n: {
    messages: {
      de: {
        error: {
          titles: {
            forbidden: 'Unerlaubter Zugriff',
          },
          hints: {
            forbidden: `Die angeforderte Seite kann aufgrund fehlender
                        Zugriffsberechtigungen nicht angezeigt werden. Bitte
                        wende dich an einen Administrator, falls du glaubst,
                        dass es sich um einen Fehler handelt.`,
          },
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ForbiddenView.vue?5392c7b2